import { t } from 'i18next';
import React from 'react';

import { GemIcon } from 'src/components/icons';
import type { StudioEntitlements } from 'src/hooks/usePlanStatusHook';
import type { StudioFeature } from 'src/routes/settings/plans/components/studio/studioFeatureGating';

import { UpgradeBadge } from './UpgradeBadge';

interface SettingsUpgradeBadgeProps {
  /** Studio entitlements from `usePlanStatus().studio`. */
  studio: StudioEntitlements;
  /** The entitlement-matrix feature this settings section maps to. */
  feature: StudioFeature;
  /**
   * Classic fallback: whether to show the legacy diamond upgrade icon when the
   * workspace is not on Studio pricing. Keeps Classic behavior unchanged.
   */
  legacyShow?: boolean;
}

export const SettingsUpgradeBadge: React.FC<SettingsUpgradeBadgeProps> = ({
  studio,
  feature,
  legacyShow = false,
}) => {
  if (!studio.isStudioPricingWorkspace) {
    return <UpgradeBadge show={legacyShow} />;
  }
  if (studio.isCurrentPlanLoading) {
    return null;
  }
  if (studio.hasFeatureAccess(feature)) {
    return null;
  }
  return (
    <span className="inline-flex items-center gap-1 rounded-md bg-assembly-blue-primary px-1.5 py-0.5 text-black-heading">
      <GemIcon style={{ fontSize: 14 }} />
      <span className="text-[12px] font-normal leading-5">
        {t(($) => $.page_studio_plans.choose_plan.upgrade)}
      </span>
    </span>
  );
};
